import $, { event } from "jquery"
window.jQuery = $
window.$ = $

// PLUGINS======================================================================================
// import Inputmask from "inputmask"
import "@fancyapps/fancybox"
// import LazyLoad from "vanilla-lazyload"
import "./js-plugins/selectize"

// MODULES======================================================================================
import "./js-modules/sliders.js"
import "./js-modules/storiesSlider.js"
import "./js-modules/compare.js"
import "./js-modules/cart-info.js"
import "./js-modules/form-toggle.js"
import "./js-modules/upload.js"

// import initDropdowns from './js-modules/dropdowns'
// import initShowmore from "./js-modules/showmore"
import initPreloader from "./js-modules/preloader.js";
import initAnimations from "./js-modules/animations"
import initTabs from "./js-modules/tabs"
import Popup from "./js-modules/popup";
import initAccordion from './js-modules/accordion'
import initFiltersToggle from './js-modules/filters-toggle'
import initOrderToggle from './js-modules/order-toggle'
import fileUpload from './js-modules/upload-file'
import oneHeightElements from './js-modules/one-height'
import initMobilemenu from "./js-modules/mobilemenu"
import initDataPicker from "./js-modules/datapicker"

// init ========================================================================================
document.addEventListener("DOMContentLoaded", () => {
    // let lazyload = new LazyLoad()
    // fancybox
    $(".fancybox").fancybox({
        trapFocus: false,
        // touch: false,
        buttons: ["fullscreen", "close", "thumbs"],
        image: {
        preload: true,
        },
        transitionEffect: "slide",
    });
    // selectize
    if($(window).width() > 1040) {
        $('.selectize-select').selectize({
        maxItems: 1,
        });
    }
    // $.fancybox.defaults.backFocus = false
    // let im = new Inputmask("+7 (999) 999-99-99")
    // im.mask(document.querySelectorAll('input[type="tel"]'))
    // initShowmore()
    // initDropdowns()

    // popup
    window.popup = new Popup('[data-popup]')

    initPreloader()
    initAnimations()
    initAccordion()
    initMobilemenu()
    initFiltersToggle()
    window.initCartInfo()
    window.initFormToggle()
    initOrderToggle()
    window.initUpload()
    fileUpload()
    initDataPicker()
    initTabs()

    // oneHeiight
    oneHeightElements($('.compare-sort__link'))

    // header-search
    $('.search-btn').on('click', function() {
        $('.header-btns__item--search').toggleClass('js__open');
        $('.header').toggleClass('search-open');
    });

    $('.header-search__close').on('click', function() {
        $('.header-btns__item--search').removeClass('js__open');
        $('.header').removeClass('search-open');
    });

    // product-nav
    $('.product-inner__nav').each(function(){
        $(this).find('.product-inner__nav-title').on('click', function() {
            $(this).toggleClass('js__open');
            $(this).siblings('.product-inner__nav-list').slideToggle();
        });

        $(this).find('.product-inner__nav-link').on('click', function() {
            $('.product-inner__nav-title').toggleClass('js__open');
            $('.product-inner__nav-list').slideToggle();
        });
    });

    // mobile-menu
    $('.mobile-menu .catalog-menu__item.has-submenu').each(function(){
        $(this).append('<div class="submenu-toggle"/>')
        $(this).find('.submenu-toggle').on('click', function() {
            $(this).toggleClass('js__open');
            $(this).siblings('.catalog-submenu').slideToggle();
        });
    });

    //надо открыть пункты описания в карточке товара
    $('.product-inner__bottom .accordion__head').addClass('js__open');
    $('.product-inner__bottom .accordion__body').css({'display' : 'block'});

})
